// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=ebfe83aa-56b7-42d0-9ada-e61f79e0432c";
};